/**
 * WebView→app message types posted by the Expo native shell that should
 * (re)register the device's push token. Both the initial load AND a
 * post-rotation token update must register: if `webviewTokenUpdated` is not
 * handled, a rotated Expo token is never re-sent to the backend and AI Coach
 * push delivery silently goes stale for that device (SCO-376).
 */
var PUSH_TOKEN_REGISTRATION_MESSAGES = [
    'webviewLoaded',
    'webviewTokenUpdated'
];
export default function isPushTokenRegistrationMessage(type) {
    return PUSH_TOKEN_REGISTRATION_MESSAGES.includes(type);
}
